import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

// Импорт шрифтов как URL
import RobotoRegular from "@/assets/fonts/Roboto/Roboto-Regular.ttf";
import RobotoBold from "@/assets/fonts/Roboto/Roboto-Bold.ttf";

/**
 * Загружает шрифт и конвертирует его в base64
 */
const loadFontAsBase64 = async (fontUrl) => {
  try {
    const response = await fetch(fontUrl);
    const blob = await response.blob();

    return await blobToBase64(blob);
  } catch (error) {
    console.error("Ошибка загрузки шрифта PDF файла:", error);
    return null;
  }
};

/**
 * Конвертирует Blob в base64
 */
const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result.split(",")[1]);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};


export async function downloadChart(chartsRefs, title, filename = "analytics"){
  // Экземпляр jsPDF
  const doc = new jsPDF({
    putOnlyUsedFonts: true,
    orientation: "portrait",
    unit: "mm",
    format: "a4"
  });

  // Дата формирования отчета
  const today = new Date().toLocaleDateString("ru-RU").replaceAll(".", "-");

  // Функция добавления фонового цвета на активную страницу
  const addBackgroundColor = () => {
    doc.setFillColor(238, 241, 244); // #EEF1F4
    doc.rect(0, 0, 210, 297, "F"); // A4 размер в мм (210x297)
  };

  // Добавляем фон для первой страницы
  addBackgroundColor();

  // Добавляем шрифты с поддержкой кириллицы (Roboto)
  try {
    const robotoRegularBase64 = await loadFontAsBase64(RobotoRegular);
    const robotoBoldBase64 = await loadFontAsBase64(RobotoBold);

    if (robotoRegularBase64) {
      doc.addFileToVFS("Roboto-Regular.ttf", robotoRegularBase64);
      doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");
    }

    if (robotoBoldBase64) {
      doc.addFileToVFS("Roboto-Bold.ttf", robotoBoldBase64);
      doc.addFont("Roboto-Bold.ttf", "Roboto", "bold");
    }

    doc.setFont("Roboto");
  } catch (error) {
    console.error("Ошибка загрузки шрифтов:", error);
    doc.setFont("helvetica");
  }

  // Заголовок страницы
  doc.setFontSize(16);
  doc.text(title, 5, 10);

  // Начальная позиция по Y после заголовка
  let yPosition = 20;

  try {
    const canvases = [];

    // Создания canvas'a с графиками.
    for (const element of chartsRefs) {
      try {
        const elementNode = element.value;

        const canvas = await html2canvas(elementNode, {
          scale: 2,
          useCORS: true,
          logging: false,
          ignoreElements: (el) => {
            return el.id === "chart-control";
          },
        });

        canvases.push(canvas);
      } catch (error) {
        console.error("Ошибка при сохранение графика в canvas:", error);
      }
    }

    canvases.forEach((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const imgWidth = 200; // Ширина изображения в PDF
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Проверяем, помещается ли изображение на текущей странице
      if (yPosition + imgHeight > 280) {
        doc.addPage();
        addBackgroundColor(); // Добавляем фон для новой страницы
        yPosition = 10; // Сброс позиции для новой страницы
      }

      // Добавляем изображение в PDF
      doc.addImage(imgData, "PNG", 5, yPosition, imgWidth, imgHeight);

      // Обновляем позицию для следующего изображения
      yPosition += imgHeight + 5; // 5 - отступ между графиками
    });

    // Сохраняем PDF
    doc.save(`${filename}_(${today}).pdf`);
  } catch (error) {
    console.error("Ошибка при создании PDF:", error);
  }
}